module.exports = new __parcel__URL__("flag-de2.6efc40f2.png").toString();